import { useRef } from 'react';
import { ToggleButton, ToggleButtonItem, ToggleButtonLabelSize } from '@apply/components';
import { useExperienceDateSold, useExperienceDateSoldTypeId } from '../../../../../../fields/ExperienceFields';
import { ExperienceDateType } from '@apply/constants';
import { ItemClickEvent } from 'devextreme/ui/button_group';

interface DateOrYearToggleProps {
    experienceId: string | undefined;
    required?: boolean;
    readOnly?: boolean;
}

export const DateOrYearToggle: React.FC<DateOrYearToggleProps> = ({ experienceId, required = false, readOnly = false }) => {
    const isFirstLoad = useRef(true);
    const label = 'Year Sold ';
    const [dateSoldTypeId, set_dateSoldTypeId] = useExperienceDateSoldTypeId(experienceId);
    const [, set_dateSold] = useExperienceDateSold(experienceId);

    // Default to Exact Date
    const effectiveType = dateSoldTypeId ?? ExperienceDateType.Exact;

    const selectedToggleId = effectiveType === ExperienceDateType.Exact ? 'ExactDate' : 'YearOnly';

    const dateOrYearOptions: ToggleButtonItem[] = [
        {
            id: 'ExactDate',
            text: 'Exact Date',
            hint: 'Exact Date',
        },
        {
            id: 'YearOnly',
            text: 'Year Only',
            hint: 'Year Only',
        },
    ];

    const onDateSoldTypeChange = (value: ItemClickEvent) => {
        // Skip the first change triggered by initial load
        if (isFirstLoad.current) {
            isFirstLoad.current = false;

            // Only skip if editing an existing experience
            if (dateSoldTypeId !== undefined && dateSoldTypeId !== null) {
                return;
            }
        }

        set_dateSold(undefined);
        set_dateSoldTypeId(value.itemData.id === 'ExactDate' ? ExperienceDateType.Exact : ExperienceDateType.YearOnly);
    };

    return (
        <ToggleButton
            id='toggleButtonUndergroundStorageTanks'
            items={dateOrYearOptions}
            selectedItems={[selectedToggleId]}
            stylingMode='outlined'
            selectionMode='single'
            onItemClick={(e) => onDateSoldTypeChange(e)}
            width='220px'
            required={required}
            label={label}
            labelSize={ToggleButtonLabelSize.Small}
            height='28px'
        />
    );
};
